import React, { Component } from 'react'
import { Alert } from '@ticketswap/solar'
import { withTranslation } from '~/i18n'

class ErrorBoundary extends Component {
  state = { hasError: false }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return <Alert variant="warning">{this.props.t('common:generic.somethingWentWrong')}</Alert>
    }

    return this.props.children
  }
}

export default withTranslation('common')(ErrorBoundary)
